import React, { useState } from "react";
// import "./style.css";
import "./ContactPage.scss";
import { MdCall } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { IoTime } from "react-icons/io5";
import { IoPerson } from "react-icons/io5";
import { FaHome, FaTelegramPlane } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { contactusEntry } from "../services/apiservice"; // Import API function
import successGif from "../assets/images/namastehands.jpg"; // Import your success GIF




export default function ContactUs() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    emailid: "",
    address: "",
    message: "",
  });


  // Define state variables for error messages
  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    emailid: "",
    address: "",
    message: "",
  });

  // Define loading state for the button animation
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    // Redirect to the YouTube video when the button is clicked
    window.location.href = "https://www.youtube.com/watch?v=uqZPq6mZhSI";
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [showPopup, setShowPopup] = useState(false); // State for success popup

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    // Validation logic
    let formValid = true;
    let formErrors = {
      name: "",
      mobile: "",
      emailid: "",
      address: "",
      message: "",
    };

    // Email regex pattern to validate format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if any fields are empty
    if (!formData.name) {
      formErrors.name = "Please enter your Name";
      formValid = false;
    }
    if (!formData.emailid) {
      formErrors.emailid = "Please enter Email";
      formValid = false;
    } else if (!emailRegex.test(formData.emailid)) {
      formErrors.emailid = "Please enter a valid Email address";
      formValid = false;
    }
    if (!formData.mobile) {
      formErrors.mobile = "Please enter a valid 10-digit Phone Number";
      formValid = false;
    }
    if (!formData.message) {
      formErrors.message = "Please enter Message";
      formValid = false;
    }
    if (!formData.address) {
      formErrors.address = "Please enter Address";
      formValid = false;
    }

    // Set the error messages in state
    setErrors(formErrors);

    if (formValid) {
      // Start the loading effect
      setIsLoading(true);

      try {
        const response = await contactusEntry(formData);
        setShowPopup(true);
        // Hide popup after 5 seconds
      } catch (error) {
        setErrors(error.response?.data?.message || "Something went wrong. Please try again.");
      }

      // Simulate a 3-second delay
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);// 1-second delay
      setFormData({ name: "", mobile: "", emailid: "", address: "", message: "" }); // Reset form
    } else {
      // toast.error("Please fill in all fields correctly!"); // Show error toast if form is not valid
    }
  };



  return (
    <>

      <div className="fill-the-form-below">
      {showPopup && (
              <div className="success-popup">
                <img src={successGif} alt="Success"  />
                <p>संपर्क केल्याबद्दल धन्यवाद!</p>
              </div>
            )}

        {!showPopup &&(<div className="container">
        
          <div className="left-container">
            <div className="title-container">
              <label htmlFor="">let's talk</label>
              <h2 className="title">Speak with Our Experts</h2>
            </div>
            <div className="address-box">
              <div className="address-icon">
                <FaHome />
                {/* <FontAwesomeIcon icon={faHome} className="icon" /> */}
              </div>
              <div className="address-text">
                <span className="label">Email :</span>
                <div className="desc" to={"support@dattamandir.com"} style={{textTransform:"none"}}>
                support@dattamandir.com
                </div>
              </div>
            </div>
            <div className="address-box">
              <div className="address-icon">
                <MdCall />
                {/* <FontAwesomeIcon icon={faPhone} className="icon" /> */}
              </div>
              <div className="address-text">
                <span className="label">Phone :</span>
                <div className="desc" to={"support@dattamandir.com"}>
                +91 9422070407
                </div>
              </div>
            </div>
            <div className="address-box">
              <div className="address-icon">
                <FaLocationDot />
                {/* <FontAwesomeIcon icon={faLocationPin} className="icon" /> */}
              </div>
              <div className="address-text">
                <span className="label">Address :</span>
                <div className="desc" to={"support@econsignsoft.com"}>
                श्री दत्त मंदिर संस्थान रुईभर.
                </div>
              </div>
            </div>
          </div>
          <div className="right-container">
            <div className="title-container2">
              <label className="contact-sub-text">Get In Touch</label>
              <br />
              <br />
              <h2 style={{ fontSize: "32px" }}>Fill The Form Below</h2>
            </div>
            
            <form className="form-container" onSubmit={handleSubmit}>
              <div className="form-input-container">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  style={
                    !formData.name && errors.name
                      ? { border: "1px solid #DC4C64" }
                      : undefined
                  }
                  value={formData.name} onChange={handleChange}
                />
                {!formData.name && errors.name && (
                  <span className="error-message">{errors.name}</span>
                )}
              </div>
              <div className="form-input-container">
                <input
                  type="text"
                  name="emailid"
                  placeholder="Email-Id"
                  style={
                    !formData.emailid && errors.emailid
                      ? { border: "1px solid #DC4C64" }
                      : undefined
                  }
                  value={formData.emailid} onChange={handleChange}
                />
                {!formData.emailid && errors.emailid && (
                  <span className="error-message">{errors.emailid}</span>
                )}
              </div>
              <div className="form-input-container">
                <input
                  type="text"
                  name="mobile"
                  placeholder="Phone Number"
                  style={
                    !formData.mobile && errors.phone
                      ? { border: "1px solid #DC4C64" }
                      : undefined
                  }
                  value={formData.mobile} onChange={handleChange}
                />
                {!formData.mobile && errors.mobile && (
                  <span className="error-message">{errors.mobile}</span>
                )}
              </div>
              <div className="form-input-container">
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  style={
                    !formData.address && errors.address
                      ? { border: "1px solid #DC4C64" }
                      : undefined
                  }
                  value={formData.address} onChange={handleChange}
                />
                {!formData.address && errors.address && (
                  <span className="error-message">{errors.address}</span>
                )}
              </div>
              <div className="form-textarea-container">
                <textarea
                  placeholder="Your Message Here"
                  name="message"
                  rows={5}
                  value={formData.message}
                  style={
                    !formData.message && errors.message
                      ? { border: "1px solid #DC4C64" }
                      : undefined
                  }
                  onChange={handleChange}
                ></textarea>
                {!formData.message && errors.message && (
                  <span className="error-message">{errors.message}</span>
                )}
              </div>
              <div className="submit-btn">
                <button type="submit" disabled={isLoading}>
                   Submit Now
                </button>
              </div>
            </form>
          </div>
        </div>)}
      </div>
      {/* </div> */}

    </>
  );
}
